__turbopack_context__.v({
  "clipDef": "HeroSwirlCircle-module__ByQemW__clipDef",
});
